import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Company } from 'src/app/domains/companies/models';
import { VerificationData } from 'src/app/domains/dids/models';
import { VerificationDataService } from 'src/app/domains/dids/services';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { VdDetailsPopupComponent } from '../vd-details-popup/vd-details-popup.component';

@Component({
  selector: 'gdp-verification-data-table',
  templateUrl: './verification-data-table.component.html',
  styleUrls: ['./verification-data-table.component.scss']
})
export class VerificationDataTableComponent implements OnInit {
  @Input() verificationDataList: VerificationData[];
  @Input() loading: boolean;
  @Input() company: Company;

  constructor(
    private verificationDataService: VerificationDataService,
    private notification: NotificationService,
    private modalService: NgbModal) { }

  ngOnInit() {
  }

  openVDDetailsPopup(vd: VerificationData) {
    const modal = this.modalService.open(VdDetailsPopupComponent, {
      size: 'lg'
    });
    modal.componentInstance.verificationData = vd;
  }

  deleteVerificationData(data: VerificationData) {
    this.notification.showConfirmation('company.dids.verification-data.confirm-delete').then((result: string) => {
      if (result === 'ok') {
        data._isDeleting = true;
        this.verificationDataService.deleteVerificationData(data.id,
          [
            {
              status: 404,
              message: 'company.dids.verification-data.error-delete'
            },
            {
              status: 409,
              message: 'company.dids.verification-data.error-conflict'
            }
          ])
        .subscribe((res: any) => {
          this.verificationDataList = this.verificationDataList.filter((el) => el.id !== data.id);
          data._isDeleting = false;
          this.notification.success('company.dids.verification-data.success-delete');
        }, () => {
          data._isDeleting = false;
        });
      }
    });
  }
}
